import styled from 'styled-components';

export const FreemiumContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${props => !(props.isUnlimited) &&'#f8f6f2'};
  border: ${props => !(props.isUnlimited )&& '1px solid #d4af37'};
  border-radius: 50px;
  padding: ${props => !(props.isUnlimited) && '8px 12px'};
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 14px;
  line-height: 20px;
  color: #4a4a4a;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: ${props => !(props.isUnlimited) && '#f0ede6'};
    border-color: ${props => !(props.isUnlimited) && '#d4af37'};
  }
`;

export const CreditsSection = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const CreditsIcon = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CreditsText = styled.span`
  font-weight: 500;
  color: #4a4a4a;
`;

export const PlanSection = styled.div`
  display: flex;
  align-items: center;
`;

export const PlanText = styled.span`
  font-weight: 500;
  color: #4a4a4a;
`;

export const UpgradeSection = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const UpgradeText = styled.span`
  font-weight: 600;
  color: #8a2be5;
  text-decoration: underline;
  
  &:hover {
    color: #6a1b9a;
  }
`;

export const Separator = styled.div`
  width: 1px;
  height: 20px;
  background-color: #d0d0d0;
  margin: 0 12px;
`;
